export default __webpack_public_path__ + "static/Enterprise-Ready-6c65dd2e7a9c74dd206c0f4699b0c70f.png";